// Its for making my accounts easier and Invoice purpose eg ADHD


import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
// Add collectionGroup to your firestore import at the top
import { collection, collectionGroup, getDocs, doc, setDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { ref, uploadBytesResumable, getDownloadURL, listAll } from 'firebase/storage';
import { Storage } from '../firebase'; // adjust path as needed
import { jsPDF } from 'jspdf';

const addWrappedText = (doc, text, x, y, maxWidth, lineHeight) => {
  const words = (text || '').split(' ');
  let line = '';
  let currentY = y;
  for (let i = 0; i < words.length; i++) {
    const testLine = line + words[i] + ' ';
    const testWidth = doc.getStringUnitWidth(testLine) * doc.internal.getFontSize() / doc.internal.scaleFactor;
    if (testWidth > maxWidth && i > 0) {
      doc.text(line.trim(), x, currentY);
      line = words[i] + ' ';
      currentY += lineHeight;
    } else {
      line = testLine;
    }
  }
  if (line.trim() !== '') doc.text(line.trim(), x, currentY);
  return currentY + lineHeight;
};

const B2BOrdersPage = () => {
  const [allUsers, setAllUsers] = useState([]);
  const [isAddOrderModalOpen, setIsAddOrderModalOpen] = useState(false);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  // Form state
  const [selectedUserId, setSelectedUserId] = useState('');
  const [selectedBrandName, setSelectedBrandName] = useState('');
  const [orderId, setOrderId] = useState('');
  
  // Customer Information
  const [customerName, setCustomerName] = useState('');
  const [customerLastName, setCustomerLastName] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  
  // Billing Address
  const [billingAddress, setBillingAddress] = useState('');
  const [billingAddress2, setBillingAddress2] = useState('');
  const [billingCity, setBillingCity] = useState('');
  const [billingState, setBillingState] = useState('');
  const [billingCountry, setBillingCountry] = useState('India');
  const [billingPincode, setBillingPincode] = useState('');
  
  // Shipping Address (same as billing by default)
  const [sameAsBilling, setSameAsBilling] = useState(true);
  const [shippingAddress, setShippingAddress] = useState('');
  const [shippingAddress2, setShippingAddress2] = useState('');
  const [shippingCity, setShippingCity] = useState('');
  const [shippingState, setShippingState] = useState('');
  const [shippingCountry, setShippingCountry] = useState('India');
  const [shippingPincode, setShippingPincode] = useState('');
  const [orderDate, setOrderDate] = useState(new Date().toISOString().split('T')[0]);
  
  
  // Order Details
  const [orderItems, setOrderItems] = useState([{
    name: '',
    sku: '',
    size: '',
    units: 1,
    selling_price: 0,
    itemTotalPrice: 0
  }]);
  
  const [paymentMethod, setPaymentMethod] = useState('Prepaid');
  const [shippingPreference, setShippingPreference] = useState('Surface');
  const [packageLength, setPackageLength] = useState(10);
  const [packageBreadth, setPackageBreadth] = useState(10);
  const [packageHeight, setPackageHeight] = useState(5);
  const [packageWeight, setPackageWeight] = useState(0.5);
  const [orderComment, setOrderComment] = useState('');
  
  const [saving, setSaving] = useState(false);

const fetchAllUsers = async () => {
  try {
    setLoading(true);
    const usersSnapshot = await getDocs(collection(db, 'users'));
    const users = [];
    usersSnapshot.docs.forEach(userDoc => {
      const userData = userDoc.data();
      const brandName = userData.brandName || userData.brand_name || userData.name || 'Unknown Brand';
      users.push({ id: userDoc.id, brandName, ...userData });
    });
    setAllUsers(users.sort((a, b) => a.brandName.localeCompare(b.brandName)));
    // ← no setLoading(false) here anymore
  } catch (error) {
    console.error('Error fetching users:', error);
    setLoading(false); // only on error
  }
};


  const fetchB2BOrders = async () => {
  try {
    const ordersSnapshot = await getDocs(collectionGroup(db, 'B2BOrders'));
    const allOrders = ordersSnapshot.docs.map(orderDoc => ({
      id: orderDoc.id,
      userId: orderDoc.ref.parent.parent.id,
      ...orderDoc.data()
    }));

    setOrders(allOrders.sort((a, b) => {
      const dateA = a.order_date ? new Date(a.order_date) : new Date(0);
      const dateB = b.order_date ? new Date(b.order_date) : new Date(0);
      return dateB - dateA;
    }));
  } catch (error) {
    console.error('Error fetching B2B orders:', error);
    alert('Failed to load orders: ' + error.message); // surface the real error
  } finally {
    setLoading(false); // always stop spinner here
  }
};

// Single useEffect — remove both old ones and replace with just this
useEffect(() => {
  const loadAll = async () => {
    await fetchAllUsers(); // users first (for the dropdown)
    await fetchB2BOrders(); // then orders
  };
  loadAll();
}, []);

  // Handle brand selection
  const handleBrandSelect = (e) => {
    const userId = e.target.value;
    setSelectedUserId(userId);
    
    const selectedUser = allUsers.find(user => user.id === userId);
    if (selectedUser) {
      setSelectedBrandName(selectedUser.brandName);
    }
  };

  // Add new item to order
  const addOrderItem = () => {
    setOrderItems([...orderItems, {
      name: '',
      sku: '',
      size: '',
      units: 1,
      selling_price: 0,
      itemTotalPrice: 0
    }]);
  };

  // Remove item from order
  const removeOrderItem = (index) => {
    if (orderItems.length > 1) {
      const newItems = orderItems.filter((_, i) => i !== index);
      setOrderItems(newItems);
    }
  };

  // Update order item
  const updateOrderItem = (index, field, value) => {
    const newItems = [...orderItems];
    newItems[index][field] = value;
    
    // Calculate item total
    if (field === 'units' || field === 'selling_price') {
      const units = field === 'units' ? parseInt(value) || 0 : newItems[index].units;
      const price = field === 'selling_price' ? parseFloat(value) || 0 : newItems[index].selling_price;
      newItems[index].itemTotalPrice = units * price;
    }
    
    setOrderItems(newItems);
  };

  // Calculate total order price
  const calculateTotalPrice = () => {
    return orderItems.reduce((total, item) => {
      return total + (item.itemTotalPrice || 0);
    }, 0);
  };

  // Reset form
  const resetForm = () => {
    setSelectedUserId('');
    setSelectedBrandName('');
    setOrderId('');
    setCustomerName('');
    setCustomerLastName('');
    setCustomerEmail('');
    setCustomerPhone('');
    setBillingAddress('');
    setBillingAddress2('');
    setBillingCity('');
    setBillingState('');
    setBillingCountry('India');
    setBillingPincode('');
    setSameAsBilling(true);
    setShippingAddress('');
    setShippingAddress2('');
    setShippingCity('');
    setShippingState('');
    setShippingCountry('India');
    setShippingPincode('');
    setOrderItems([{
      name: '',
      sku: '',
      size: '',
      units: 1,
      selling_price: 0,
      itemTotalPrice: 0
    }]);
    setPaymentMethod('Prepaid');
    setShippingPreference('Surface');
    setPackageLength(10);
    setPackageBreadth(10);
    setPackageHeight(5);
    setPackageWeight(0.5);
    setOrderComment('');
  };

  // Save order to Firestore
  const saveOrder = async () => {
    // Validation
    if (!selectedUserId) {
      alert('Please select a brand');
      return;
    }
    
    if (!orderId.trim()) {
      alert('Please enter an Order ID');
      return;
    }
    
    if (!customerName.trim()) {
      alert('Please enter customer name');
      return;
    }
    
    if (!customerEmail.trim()) {
      alert('Please enter customer email');
      return;
    }
    
    if (!customerPhone.trim()) {
      alert('Please enter customer phone');
      return;
    }
    
    if (!billingAddress.trim() || !billingCity.trim() || !billingState.trim() || !billingPincode.trim()) {
      alert('Please fill in all billing address fields');
      return;
    }
    
    // Validate order items
    for (let i = 0; i < orderItems.length; i++) {
      const item = orderItems[i];
      if (!item.name.trim() || !item.sku.trim() || !item.size.trim() || item.units <= 0 || item.selling_price <= 0) {
        alert(`Please fill in all details for item ${i + 1}`);
        return;
      }
    }
    
    setSaving(true);
    
    try {
      const totalPrice = calculateTotalPrice();
      const totalPriceWithTax = parseFloat((totalPrice * 1.05).toFixed(2));
      // Prepare shipping address (use billing if same)
      const finalShippingAddress = sameAsBilling ? billingAddress : shippingAddress;
      const finalShippingAddress2 = sameAsBilling ? billingAddress2 : shippingAddress2;
      const finalShippingCity = sameAsBilling ? billingCity : shippingCity;
      const finalShippingState = sameAsBilling ? billingState : shippingState;
      const finalShippingCountry = sameAsBilling ? billingCountry : shippingCountry;
      const finalShippingPincode = sameAsBilling ? billingPincode : shippingPincode;
      
      const orderData = {
        // Order metadata
        order_id: orderId,
        order_date: orderDate,
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
        status: 'confirmed',
        is_b2b_order: true,
        
        // Customer information
        billing_customer_name: customerName,
        billing_last_name: customerLastName,
        billing_email: customerEmail,
        billing_phone: customerPhone,
        
        // Billing address
        billing_address: billingAddress,
        billing_address_2: billingAddress2,
        billing_city: billingCity,
        billing_state: billingState,
        billing_country: billingCountry,
        billing_pincode: billingPincode,
        
        // Shipping address
        shipping_customer_name: customerName,
        shipping_last_name: customerLastName,
        shipping_email: customerEmail,
        shipping_phone: customerPhone,
        shipping_address: finalShippingAddress,
        shipping_address_2: finalShippingAddress2,
        shipping_city: finalShippingCity,
        shipping_state: finalShippingState,
        shipping_country: finalShippingCountry,
        shipping_pincode: finalShippingPincode,
        
        // Order items
        order_items: orderItems.map(item => ({
          name: item.name,
          sku: item.sku,
          size: item.size,
          units: parseInt(item.units),
          selling_price: parseFloat(item.selling_price),
          itemTotalPrice: parseFloat(item.itemTotalPrice)
        })),
        
        // Pricing
      total: totalPriceWithTax,
UniteeTotalPrice: totalPriceWithTax,
        
        // Payment and shipping
        payment_method: paymentMethod,
        financial_status: paymentMethod === 'Prepaid' ? 'paid' : 'pending',
        shippingPreference: shippingPreference,
        
        // Package details
        length: parseFloat(packageLength),
        breadth: parseFloat(packageBreadth),
        height: parseFloat(packageHeight),
        weight: parseFloat(packageWeight),
        
        // Additional info
        comment: orderComment,
        brandName: selectedBrandName,        
        // // No tracking details initially
        // tracking_status: 'printing pending'
      };
      
      const invoiceUrl = await generateB2BInvoice({ ...orderData, order_id: orderId }, orderDate);
orderData.invoiceUrl = invoiceUrl;
      // Save to Firestore: users/{userId}/B2BOrders/{orderId}
      const orderRef = doc(db, 'users', selectedUserId, 'B2BOrders', orderId);
      await setDoc(orderRef, orderData);
      
      // alert(`B2B Order ${orderId} created successfully!`);
      
      // // Reset and close
      // resetForm();
      // setIsAddOrderModalOpen(false);
      
      // // Refresh orders list
      // await fetchB2BOrders();

      const newOrder = {
  id: orderId,
  userId: selectedUserId,
  brandName: selectedBrandName,
  ...orderData
};
setOrders(prev => [newOrder, ...prev]); // instant UI update

alert(`B2B Order ${orderId} created successfully!`);
resetForm();
setIsAddOrderModalOpen(false);

// background refresh to stay in sync (no await)
fetchB2BOrders();
      
    } catch (error) {
      console.error('Error saving order:', error);
      alert('Failed to save order: ' + error.message);
    } finally {
      setSaving(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString();
  };

  const generateB2BInvoice = async (orderData, selectedDate) => {
  const folderPath = `B2bInvoices/2026-27/`;
  const storageRef = ref(Storage, folderPath);

  let nextNumber = 1;
  try {
    const listResult = await listAll(storageRef);
    if (listResult.items.length > 0) {
      const numbers = listResult.items
        .map(item => item.name.match(/UC_B2B_2627_(\d+)\.pdf$/))
        .filter(Boolean)
        .map(match => parseInt(match[1], 10));
      if (numbers.length > 0) nextNumber = Math.max(...numbers) + 1;
    }
  } catch (e) {}

  const invoiceNumberStr = String(nextNumber).padStart(2, '0');
  const invoiceNumber = `UC/B2B/26-27/${invoiceNumberStr}`;
  const fileName = `UC_B2B_2627_${invoiceNumberStr}.pdf`;

  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const margin = 15, width = 180, startX = margin;
  let currentY = margin;
  const lineHeight = 6;

  // Use the selected date
  const invoiceDate = new Date(selectedDate).toLocaleDateString('en-GB', {
    day: '2-digit', month: 'short', year: '2-digit'
  });

  // Title
  doc.setFontSize(16);
  doc.setFont('Helvetica', 'bold');
  doc.text('TAX INVOICE', width / 2 + startX, currentY += lineHeight, null, null, 'center');
  currentY += lineHeight;

  doc.setFontSize(10);
  doc.setFont('Helvetica', 'normal');
  doc.text(`Date: ${invoiceDate}`, startX, currentY += lineHeight);
  doc.text(`Invoice #: ${invoiceNumber}`, startX + width / 2, currentY);
  currentY += lineHeight / 2;
  doc.line(startX, currentY, startX + width, currentY);
  currentY += lineHeight / 2;

  // Bill From
  doc.setFont('Helvetica', 'bold');
  doc.text('Bill From:', startX, currentY += lineHeight);
  doc.setFont('Helvetica', 'normal');
  currentY += lineHeight;
  doc.setFont('Helvetica', 'bold');
  doc.text('UNITEE STUDIOS PRIVATE LIMITED', startX, currentY);
  doc.setFont('Helvetica', 'normal');
  currentY += lineHeight;
  currentY = addWrappedText(doc, '1ST FLOOR, PLOT 304/E/, 3, WAKHARIA BUILDING', startX, currentY, width - 5, lineHeight);
  doc.text('Vithalbhai Patel Road, Mumbai', startX, currentY);
  currentY += lineHeight;
  doc.text('Maharashtra, India', startX, currentY);
  currentY += lineHeight;
  doc.text('GSTIN: 27AADCU3575G1Z5', startX, currentY);
  currentY += lineHeight;
  doc.text('Email: rajprit@uniteeculture.com', startX, currentY);
  currentY += lineHeight;
  doc.line(startX, currentY, startX + width, currentY);
  currentY += lineHeight / 2;

  // Bill To
  doc.setFont('Helvetica', 'bold');
  doc.text('Bill To:', startX, currentY += lineHeight);
  doc.setFont('Helvetica', 'normal');
  currentY += lineHeight;
  doc.text(`${orderData.billing_customer_name} ${orderData.billing_last_name || ''}`.trim(), startX, currentY);
  currentY += lineHeight;
  currentY = addWrappedText(doc, orderData.billing_address, startX, currentY, width - 5, lineHeight);
  doc.text(`${orderData.billing_city}, ${orderData.billing_state} - ${orderData.billing_pincode}`, startX, currentY);
  currentY += lineHeight;
  doc.text(`Phone: ${orderData.billing_phone}`, startX, currentY);
  currentY += lineHeight;
  doc.text(`Email: ${orderData.billing_email}`, startX, currentY);
  currentY += lineHeight;
  doc.line(startX, currentY, startX + width, currentY);
  currentY += lineHeight / 2;

  // Brand & Order ID
  doc.setFont('Helvetica', 'bold');
  doc.text(`Brand: ${orderData.brandName}`, startX, currentY += lineHeight);
  doc.text(`Order ID: ${orderData.order_id}`, startX + width / 2, currentY);
  currentY += lineHeight / 2;
  doc.line(startX, currentY, startX + width, currentY);
  currentY += lineHeight / 2;

  // Items header — no Size/SKU columns
  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Product Name', startX, currentY += lineHeight);
  doc.text('Qty', startX + 120, currentY, null, null, 'center');
  doc.text('Price', startX + 148, currentY, null, null, 'center');
  doc.text('Total', startX + width, currentY, null, null, 'right');
  currentY += lineHeight / 2;
  doc.line(startX, currentY, startX + width, currentY);
  currentY += lineHeight / 2;

  // Items rows — no SKU/size rendering
  doc.setFont('Helvetica', 'normal');
  let grandTotal = 0;
  orderData.order_items.forEach(item => {
    const itemTotal = item.units * item.selling_price;
    grandTotal += itemTotal;
    const firstLineY = currentY + lineHeight;
    addWrappedText(doc, item.name, startX, firstLineY, 100, lineHeight);
    doc.text(String(item.units), startX + 120, firstLineY, null, null, 'center');
    doc.text(`${item.selling_price.toFixed(2)}`, startX + 148, firstLineY, null, null, 'center');
    doc.text(`${itemTotal.toFixed(2)}`, startX + width, firstLineY, null, null, 'right');
    currentY = firstLineY + lineHeight * 1.5;
  });

  doc.line(startX, currentY, startX + width, currentY);
  currentY += lineHeight / 2;

  // Tax & Total
  const taxRate = 0.05;
  const taxAmount = grandTotal * taxRate;
  const finalTotal = grandTotal + taxAmount;

  doc.setFont('Helvetica', 'normal');
  doc.text('Subtotal (Excl. Tax):', startX, currentY += lineHeight);
  doc.text(`${grandTotal.toFixed(2)}`, startX + width, currentY, null, null, 'right');
  currentY += lineHeight;
  doc.text('GST (5%):', startX, currentY);
  doc.text(`${taxAmount.toFixed(2)}`, startX + width, currentY, null, null, 'right');
  currentY += lineHeight / 2;
  doc.line(startX, currentY, startX + width, currentY);
  currentY += lineHeight / 2;

  doc.setFontSize(13);
  doc.setFont('Helvetica', 'bold');
  doc.text('TOTAL:', startX, currentY += lineHeight);
  doc.text(`${finalTotal.toFixed(2)}`, startX + width, currentY, null, null, 'right');
  currentY += lineHeight;

  doc.setFontSize(9);
  doc.setFont('Helvetica', 'normal');
  doc.text(`Payment: ${orderData.payment_method}  |  Shipping: ${orderData.shippingPreference}`, startX, currentY += lineHeight);
  currentY += lineHeight / 2;
  doc.line(startX, currentY, startX + width, currentY);
  currentY += lineHeight / 2;
  doc.text('Thank you for your business!', startX + width / 2, currentY += lineHeight, null, null, 'center');

  // Upload
  const pdfBlob = doc.output('blob');
  const uploadRef = ref(Storage, `${folderPath}${fileName}`);
  await uploadBytesResumable(uploadRef, pdfBlob);
  return getDownloadURL(uploadRef);
};

  return (
    <div className="admin-orders-page">
      {/* Header */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">B2B Orders Management</h1>
            <p className="text-gray-600 mt-1">Manually create and manage B2B orders</p>
          </div>
          <button
            onClick={() => setIsAddOrderModalOpen(true)}
            className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-lg"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            Add B2B Order
          </button>
        </div>
      </div>

      {/* Orders Summary */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
        <div className="flex gap-8">
          <div className="text-center">
            <h3 className="text-3xl font-bold text-blue-600">{orders.length}</h3>
            <p className="text-gray-600 mt-1">Total B2B Orders</p>
          </div>
          <div className="text-center">
            <h3 className="text-3xl font-bold text-green-600">
              {orders.reduce((sum, order) => sum + (order.order_items?.length || 0), 0)}
            </h3>
            <p className="text-gray-600 mt-1">Total Items</p>
          </div>
          <div className="text-center">
            <h3 className="text-3xl font-bold text-purple-600">
              ₹{orders.reduce((sum, order) => sum + (order.total || 0), 0).toFixed(2)}
            </h3>
            <p className="text-gray-600 mt-1">Total Value</p>
          </div>
        </div>
      </div>

      {/* Orders Table */}
      {loading ? (
        <div className="flex justify-center items-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-200 border-t-blue-600"></div>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <table className="admin-orders-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Brand</th>
                <th>Customer Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Items</th>
                <th>Total Amount</th>
                <th>Status</th>
                <th>Order Date</th>
               <th>Invoice</th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0 ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                    No B2B orders found. Click "Add B2B Order" to create one.
                  </td>
                </tr>
              ) : (
                orders.map(order => (
                  <tr key={order.id}>
                    <td style={{ fontWeight: 'bold', color: '#007bff' }}>{order.order_id}</td>
                    <td>{order.brandName}</td>
                    <td>{order.billing_customer_name} {order.billing_last_name}</td>
                    <td>{order.billing_email}</td>
                    <td>{order.billing_phone}</td>
                    <td>{order.order_items?.length || 0}</td>
                    <td style={{ fontWeight: 'bold' }}>₹{order.total?.toFixed(2) || '0.00'}</td>
                    <td>{order.payment_method}</td>
                   
                  
                    <td>{formatDate(order.order_date)}</td>
                   <td>
  {order.invoiceUrl ? (
    
      <a href={order.invoiceUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-block',
        padding: '6px 12px',
        backgroundColor: '#28a745',
        color: 'white',
        borderRadius: '6px',
        fontSize: '12px',
        fontWeight: '600',
        textDecoration: 'none'
      }}
    >
      ⬇ Invoice
    </a>
  ) : (
    <span style={{ color: '#aaa', fontSize: '12px' }}>N/A</span>
  )}
</td>

                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Add Order Modal */}
      <Modal
        isOpen={isAddOrderModalOpen}
        onRequestClose={() => {
          if (!saving) {
            setIsAddOrderModalOpen(false);
            resetForm();
          }
        }}
        contentLabel="Add B2B Order"
        ariaHideApp={false}
        className="modal"
        overlayClassName="overlay"
        style={{
          content: {
            maxWidth: '900px',
            maxHeight: '90vh',
            overflow: 'auto'
          }
        }}
      >
        <div style={{ padding: '20px' }}>
          <h2 style={{ marginBottom: '20px', fontSize: '24px', fontWeight: 'bold' }}>Add New B2B Order</h2>
          
          {/* Brand Selection */}
          <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
            <h3 style={{ marginBottom: '15px', fontSize: '18px', fontWeight: '600' }}>Select Brand *</h3>
            <select
              value={selectedUserId}
              onChange={handleBrandSelect}
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #dee2e6',
                borderRadius: '6px',
                fontSize: '16px'
              }}
              required
            >
              <option value="">-- Select Brand --</option>
              {allUsers.map(user => (
                <option key={user.id} value={user.id}>
                  {user.brandName}
                </option>
              ))}
            </select>
          </div>

          {/* Order ID */}
          <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
            <h3 style={{ marginBottom: '15px', fontSize: '18px', fontWeight: '600' }}>Order Information *</h3>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Order ID *</label>
              <input
                type="text"
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
                placeholder="e.g., B2B_001"
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #dee2e6',
                  borderRadius: '6px',
                  fontSize: '16px'
                }}
                required
              />
            </div>
          </div>

          <div style={{ marginBottom: '15px' }}>
  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Order Date *</label>
  <input
    type="date"
    value={orderDate}
    onChange={(e) => setOrderDate(e.target.value)}
    style={{
      width: '100%',
      padding: '12px',
      border: '2px solid #dee2e6',
      borderRadius: '6px',
      fontSize: '16px'
    }}
    required
  />
</div>

          {/* Customer Information */}
          <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
            <h3 style={{ marginBottom: '15px', fontSize: '18px', fontWeight: '600' }}>Customer Information *</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>First Name *</label>
                <input
                  type="text"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #dee2e6',
                    borderRadius: '6px'
                  }}
                  required
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Last Name</label>
                <input
                  type="text"
                  value={customerLastName}
                  onChange={(e) => setCustomerLastName(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #dee2e6',
                    borderRadius: '6px'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Email *</label>
                <input
                  type="email"
                  value={customerEmail}
                  onChange={(e) => setCustomerEmail(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #dee2e6',
                    borderRadius: '6px'
                  }}
                  required
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Phone *</label>
                <input
                  type="tel"
                  value={customerPhone}
                  onChange={(e) => setCustomerPhone(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #dee2e6',
                    borderRadius: '6px'
                  }}
                  required
                />
              </div>
            </div>
          </div>

          {/* Billing Address */}
          <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
            <h3 style={{ marginBottom: '15px', fontSize: '18px', fontWeight: '600' }}>Billing Address *</h3>
            <div style={{ display: 'grid', gap: '15px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Address Line 1 *</label>
                <input
                  type="text"
                  value={billingAddress}
                  onChange={(e) => setBillingAddress(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #dee2e6',
                    borderRadius: '6px'
                  }}
                  required
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Address Line 2</label>
                <input
                  type="text"
                  value={billingAddress2}
                  onChange={(e) => setBillingAddress2(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #dee2e6',
                    borderRadius: '6px'
                  }}
                />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>City *</label>
                  <input
                    type="text"
                    value={billingCity}
                    onChange={(e) => setBillingCity(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '2px solid #dee2e6',
                      borderRadius: '6px'
                    }}
                    required
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>State *</label>
                  <input
                    type="text"
                    value={billingState}
                    onChange={(e) => setBillingState(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '2px solid #dee2e6',
                      borderRadius: '6px'
                    }}
                    required
                  />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Country *</label>
                  <input
                    type="text"
                    value={billingCountry}
                    onChange={(e) => setBillingCountry(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '2px solid #dee2e6',
                      borderRadius: '6px'
                    }}
                    required
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Pincode *</label>
                  <input
                    type="text"
                    value={billingPincode}
                    onChange={(e) => setBillingPincode(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '2px solid #dee2e6',
                      borderRadius: '6px'
                    }}
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Shipping Address Toggle */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={sameAsBilling}
                onChange={(e) => setSameAsBilling(e.target.checked)}
                style={{ marginRight: '10px', width: '18px', height: '18px' }}
              />
              <span style={{ fontWeight: '500' }}>Shipping address same as billing</span>
            </label>
          </div>

          {/* Shipping Address (if different) */}
          {!sameAsBilling && (
            <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
              <h3 style={{ marginBottom: '15px', fontSize: '18px', fontWeight: '600' }}>Shipping Address *</h3>
              <div style={{ display: 'grid', gap: '15px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Address Line 1 *</label>
                  <input
                    type="text"
                    value={shippingAddress}
                    onChange={(e) => setShippingAddress(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '2px solid #dee2e6',
                      borderRadius: '6px'
                    }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Address Line 2</label>
                  <input
                    type="text"
                    value={shippingAddress2}
                    onChange={(e) => setShippingAddress2(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '2px solid #dee2e6',
                      borderRadius: '6px'
                    }}
                  />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                  <div>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>City *</label>
                    <input
                      type="text"
                      value={shippingCity}
                      onChange={(e) => setShippingCity(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '2px solid #dee2e6',
                        borderRadius: '6px'
                      }}
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>State *</label>
                    <input
                      type="text"
                      value={shippingState}
                      onChange={(e) => setShippingState(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '2px solid #dee2e6',
                        borderRadius: '6px'
                      }}
                    />
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                  <div>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Country *</label>
                    <input
                      type="text"
                      value={shippingCountry}
                      onChange={(e) => setShippingCountry(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '2px solid #dee2e6',
                        borderRadius: '6px'
                      }}
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Pincode *</label>
                    <input
                      type="text"
                      value={shippingPincode}
                      onChange={(e) => setShippingPincode(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '2px solid #dee2e6',
                        borderRadius: '6px'
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Order Items */}
          <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600' }}>Order Items *</h3>
              <button
                onClick={addOrderItem}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                + Add Item
              </button>
            </div>
            
            {orderItems.map((item, index) => (
              <div key={index} style={{
                marginBottom: '20px',
                padding: '15px',
                backgroundColor: 'white',
                border: '2px solid #dee2e6',
                borderRadius: '6px'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                  <h4 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Item {index + 1}</h4>
                  {orderItems.length > 1 && (
                    <button
                      onClick={() => removeOrderItem(index)}
                      style={{
                        padding: '6px 12px',
                        backgroundColor: '#dc3545',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px'
                      }}
                    >
                      Remove
                    </button>
                  )}
                </div>
                
                <div style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 1fr', gap: '15px', marginBottom: '15px' }}>
                  <div>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
                      Product Name *
                    </label>
                    <input
                      type="text"
                      value={item.name}
                      onChange={(e) => updateOrderItem(index, 'name', e.target.value)}
                      placeholder="e.g., Cotton T-Shirt"
                      style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #dee2e6',
                        borderRadius: '4px'
                      }}
                      required
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
                      SKU *
                    </label>
                    <input
                      type="text"
                      value={item.sku}
                      onChange={(e) => updateOrderItem(index, 'sku', e.target.value)}
                      placeholder="e.g., BRAND-TSHIRT-M-BLACK"
                      style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #dee2e6',
                        borderRadius: '4px'
                      }}
                      required
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
                      Size *
                    </label>
                    <select
                      value={item.size}
                      onChange={(e) => updateOrderItem(index, 'size', e.target.value)}
                      style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #dee2e6',
                        borderRadius: '4px'
                      }}
                      required
                    >
                      <option value="">Select</option>
                      <option value="XS">XS</option>
                      <option value="S">S</option>
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                      <option value="XXL">XXL</option>
                      <option value="XXXL">XXXL</option>
                    </select>
                  </div>
                </div>
                
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px' }}>
                  <div>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
                      Units *
                    </label>
                    <input
                      type="number"
                      min="1"
                      value={item.units}
                      onChange={(e) => updateOrderItem(index, 'units', e.target.value)}
                      style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #dee2e6',
                        borderRadius: '4px'
                      }}
                      required
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
                      Price per Unit (₹) *
                    </label>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      value={item.selling_price}
                      onChange={(e) => updateOrderItem(index, 'selling_price', e.target.value)}
                      style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #dee2e6',
                        borderRadius: '4px'
                      }}
                      required
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
                      Item Total (₹)
                    </label>
                    <input
                      type="text"
                      value={item.itemTotalPrice.toFixed(2)}
                      readOnly
                      style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #dee2e6',
                        borderRadius: '4px',
                        backgroundColor: '#e9ecef',
                        fontWeight: '600'
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
            
            <div style={{
              marginTop: '20px',
              padding: '15px',
              backgroundColor: '#e7f3ff',
              borderRadius: '6px',
              border: '2px solid #007bff'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '18px', fontWeight: '600' }}>Order Total:</span>
                <span style={{ fontSize: '24px', fontWeight: 'bold', color: '#007bff' }}>
                  ₹{calculateTotalPrice().toFixed(2)}
                </span>
              </div>
            </div>
          </div>

          {/* Payment & Shipping Details */}
          <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
            <h3 style={{ marginBottom: '15px', fontSize: '18px', fontWeight: '600' }}>Payment & Shipping</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Payment Method *</label>
                <select
                  value={paymentMethod}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #dee2e6',
                    borderRadius: '6px'
                  }}
                >
                  <option value="Prepaid">Prepaid</option>
                  <option value="COD">Cash on Delivery (COD)</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Shipping Preference *</label>
                <select
                  value={shippingPreference}
                  onChange={(e) => setShippingPreference(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #dee2e6',
                    borderRadius: '6px'
                  }}
                >
                  <option value="Surface">Surface</option>
                  <option value="Air">Air</option>
                </select>
              </div>
            </div>
          </div>

          {/* Package Details */}
          <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
            <h3 style={{ marginBottom: '15px', fontSize: '18px', fontWeight: '600' }}>Package Details</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '15px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Length (cm)</label>
                <input
                  type="number"
                  min="0"
                  step="0.1"
                  value={packageLength}
                  onChange={(e) => setPackageLength(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #dee2e6',
                    borderRadius: '6px'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Breadth (cm)</label>
                <input
                  type="number"
                  min="0"
                  step="0.1"
                  value={packageBreadth}
                  onChange={(e) => setPackageBreadth(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #dee2e6',
                    borderRadius: '6px'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Height (cm)</label>
                <input
                  type="number"
                  min="0"
                  step="0.1"
                  value={packageHeight}
                  onChange={(e) => setPackageHeight(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #dee2e6',
                    borderRadius: '6px'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Weight (kg)</label>
                <input
                  type="number"
                  min="0"
                  step="0.1"
                  value={packageWeight}
                  onChange={(e) => setPackageWeight(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #dee2e6',
                    borderRadius: '6px'
                  }}
                />
              </div>
            </div>
          </div>

          {/* Order Comment */}
          <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
            <h3 style={{ marginBottom: '15px', fontSize: '18px', fontWeight: '600' }}>Additional Notes</h3>
            <textarea
              value={orderComment}
              onChange={(e) => setOrderComment(e.target.value)}
              placeholder="Any special instructions or notes for this order..."
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #dee2e6',
                borderRadius: '6px',
                minHeight: '100px',
                fontSize: '14px',
                resize: 'vertical'
              }}
            />
          </div>

          {/* Action Buttons */}
          <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end', paddingTop: '20px', borderTop: '2px solid #dee2e6' }}>
            <button
              onClick={() => {
                if (!saving) {
                  setIsAddOrderModalOpen(false);
                  resetForm();
                  setOrderDate(new Date().toISOString().split('T')[0]);
                }
              }}
              disabled={saving}
              style={{
                padding: '12px 30px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: saving ? 'not-allowed' : 'pointer',
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              Cancel
            </button>
            <button
              onClick={saveOrder}
              disabled={saving}
              style={{
                padding: '12px 30px',
                backgroundColor: saving ? '#ccc' : '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: saving ? 'not-allowed' : 'pointer',
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              {saving ? 'Saving Order...' : 'Create B2B Order'}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default B2BOrdersPage;